export const sumBy = <T>(array: T[] | undefined, key: keyof T): number =>
  array?.reduce((total, item) => total + (Number(item[key]) || 0), 0) || 0;
